<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-if="theUserProject == 0" v-model='theProjectId' @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-select v-model="userId" @change="theDtChange" size="small" filterable clearable placeholder="请选择学员">
                    <el-option v-for="item in getProjectUserAll_data.data || []" :key="item.userId" :label="item.userName"
                        :value="item.userId">
                    </el-option>
                </el-select>
                <el-date-picker v-model="valueDate" size='small' type="datetimerange" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange"
                    value-format="yyyy-MM-dd" align="right">
                </el-date-picker>
                <el-button @click="getData()" type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>搜索
                </el-button>
                <el-button @click="Bulksure()" type="success" icon='el-icon-search' size='small' style='margin-left:10px;'>导出
                </el-button>
            </el-col>

        </el-row>

        <mytable :tableColums='tableColums_getAttendanceUserList' api='getAttendanceUserList'
            xupdateapi='updateBusinessIntroduce' :height="H - 165">

        </mytable>


    </div>
</template>
  
<script>
import qs from 'qs';
import axios from 'axios';
export default {
    data() {
        return {
            baseUrl: $Api.baseUrl_online,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            startDate: '',
            endDate: '',
            valueDate: '',
            userId: '',
            theProjectId: '',
            theUserProject: '',
            biId: null,
            theMtId: "",

            tableColums_getAttendanceUserList: {
                $selection: false,


                userName: '用户名',
                yasDes:'打卡备注',
                yasDate: '打卡日期',
                yasTimeStart: '开始时间',
                yasTimeEnd: '结束时间',
                yauTime: '已打卡时间',
                dtName: '战队',
                yauStatus: ['状态', , '@v-if: 1:未打卡#danger, 2:已打卡#success'],

                createtime: '创建时间',



            },

        };
    },

    watch: {

    },

    methods: {
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Bulksure() {
            const bulkdata = {
                projectId: this.theProjectId,
                userId: this.userId,
                yasDateStart: this.startDate,
                yasDateEnd: this.endDate,
            }
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this
            axios({
                method: 'post',
                url: that.baseUrl + '/opportunity/attendance-user/exportAttendanceUser',
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'token': A.local('$Usertoken'),
                    'projectId': +A.local('$projectId'),
                }
            }).then(function (res) {
                if (res.data) {
                    that.loading.close();
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '考勤.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        timeChange(e) {
            if (e) {
                this.startDate = e[0];
                this.endDate = e[1];
            } else {
                this.startDate = "";
                this.endDate = "";
            }

        },
        theDtChange(e) {
            this.userId = e
            this.getData();
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getData();
        },
        getData() {
            this.getAttendanceUserList({
                projectId: this.theProjectId,
                userId: this.userId,
                yasDateStart: this.startDate,
                yasDateEnd: this.endDate,
                currentPage: 1,
            });
        },
    },

    created() {
        this.theUserProject = A.local('$projectId');
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;

        }
        this.getAttendanceUserList({ projectId: A.local('$projectId') });
        this.getProjectUserAll({
            postId: 5,
            projectId: A.local('$projectId'),
        })
    }
};
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/data/clockingIn.vue